module.exports = __webpack_public_path__ + "img/instagram.ab94e876.svg";